<div
  [ngClass]="'idp-action-bar__caret-section-' + content.caret.position"
  class="idp-action-bar__caret-section"
>
  <button
    [ngClass]="'idp-action-bar__caret-button' + content.caret.type"
    [id]="content.label.id"
    class="idp-action-bar__caret-button"
    (click)="toggle()"
    [attr.aria-label]="content.caret.ariaLabel"
  >
    <i
      [class.expand]="expand"
      [ngClass]="[
        'idp-action-bar__caret-' + content.caret.type,
        'idp-action-bar__caret--arrow-position'
      ]"
      aria-hidden="true"
    ></i>
  </button>
</div>
